module.exports = __webpack_public_path__ + "media/images/avatar/4-63e85c0243dca9d32402b49924f64ba5.svg";